module.exports = __webpack_public_path__ + "img/cooperation_process3.62c9ddcb.png";